import {
  findDeepGetTask,
  isGrouped,
  recursiveGetStartForParent
} from '../../GanttVisualization.helper';
import { getIsOdd } from '../common/validators';
import { createNonTaskDateHtml, createTaskDateHtml } from './templates';
import { formatDate } from './utils';

const renderStart = ({ task, onlyRead }) => {
  const gantt = window.ganttVisualization;
  const activities = window.activities;

  if (!task || task.is_milestone || isGrouped()) return null;

  if (!task.isTask) {
    const dateStr = formatDate(task.start_date, gantt);
    return createNonTaskDateHtml(dateStr, onlyRead);
  }

  const taskFromLookahead = findDeepGetTask(activities, 'id', task.id);
  if (!taskFromLookahead) return null;

  if (taskFromLookahead.children?.length) {
    recursiveGetStartForParent(
      taskFromLookahead,
      { name: 'start_date' },
      gantt
    );
  }

  const isOdd = getIsOdd({ gantt, task }, 'start_date');
  const dateStr = formatDate(task.start_date, gantt);

  return createTaskDateHtml(dateStr, onlyRead, isOdd);
};

export default renderStart;
